import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import { css } from "@emotion/react";
import { Theme } from "@silvertours/front-shared";
// Tailwind doesn't support dynamic class names so we have to use maps with explicit values
var spansWithoutOverride = {
    "1": "col-span-1",
    "2": "col-span-2",
    "3": "col-span-3",
    "4": "col-span-4",
    "5": "col-span-5",
    "6": "col-span-6",
    "7": "col-span-7",
    "8": "col-span-8",
    "9": "col-span-9",
    "10": "col-span-10",
    "11": "col-span-11",
    "12": "col-span-12"
};
var spansWithOverride = {
    "1": "!col-span-1",
    "2": "!col-span-2",
    "3": "!col-span-3",
    "4": "!col-span-4",
    "5": "!col-span-5",
    "6": "!col-span-6",
    "7": "!col-span-7",
    "8": "!col-span-8",
    "9": "!col-span-9",
    "10": "!col-span-10",
    "11": "!col-span-11",
    "12": "!col-span-12"
};
var spansWithoutOverrideSm = {
    "1": "sm:col-span-1",
    "2": "sm:col-span-2",
    "3": "sm:col-span-3",
    "4": "sm:col-span-4",
    "5": "sm:col-span-5",
    "6": "sm:col-span-6",
    "7": "sm:col-span-7",
    "8": "sm:col-span-8",
    "9": "sm:col-span-9",
    "10": "sm:col-span-10",
    "11": "sm:col-span-11",
    "12": "sm:col-span-12"
};
var spansWithOverrideSm = {
    "1": "sm:!col-span-1",
    "2": "sm:!col-span-2",
    "3": "sm:!col-span-3",
    "4": "sm:!col-span-4",
    "5": "sm:!col-span-5",
    "6": "sm:!col-span-6",
    "7": "sm:!col-span-7",
    "8": "sm:!col-span-8",
    "9": "sm:!col-span-9",
    "10": "sm:!col-span-10",
    "11": "sm:!col-span-11",
    "12": "sm:!col-span-12"
};
var spansWithoutOverrideMd = {
    "1": "md:col-span-1",
    "2": "md:col-span-2",
    "3": "md:col-span-3",
    "4": "md:col-span-4",
    "5": "md:col-span-5",
    "6": "md:col-span-6",
    "7": "md:col-span-7",
    "8": "md:col-span-8",
    "9": "md:col-span-9",
    "10": "md:col-span-10",
    "11": "md:col-span-11",
    "12": "md:col-span-12"
};
var spansWithOverrideMd = {
    "1": "md:!col-span-1",
    "2": "md:!col-span-2",
    "3": "md:!col-span-3",
    "4": "md:!col-span-4",
    "5": "md:!col-span-5",
    "6": "md:!col-span-6",
    "7": "md:!col-span-7",
    "8": "md:!col-span-8",
    "9": "md:!col-span-9",
    "10": "md:!col-span-10",
    "11": "md:!col-span-11",
    "12": "md:!col-span-12"
};
var spansWithoutOverrideLg = {
    "1": "lg:col-span-1",
    "2": "lg:col-span-2",
    "3": "lg:col-span-3",
    "4": "lg:col-span-4",
    "5": "lg:col-span-5",
    "6": "lg:col-span-6",
    "7": "lg:col-span-7",
    "8": "lg:col-span-8",
    "9": "lg:col-span-9",
    "10": "lg:col-span-10",
    "11": "lg:col-span-11",
    "12": "lg:col-span-12"
};
var spansWithOverrideLg = {
    "1": "lg:!col-span-1",
    "2": "lg:!col-span-2",
    "3": "lg:!col-span-3",
    "4": "lg:!col-span-4",
    "5": "lg:!col-span-5",
    "6": "lg:!col-span-6",
    "7": "lg:!col-span-7",
    "8": "lg:!col-span-8",
    "9": "lg:!col-span-9",
    "10": "lg:!col-span-10",
    "11": "lg:!col-span-11",
    "12": "lg:!col-span-12"
};
var spansWithoutOverrideXl = {
    "1": "xl:col-span-1",
    "2": "xl:col-span-2",
    "3": "xl:col-span-3",
    "4": "xl:col-span-4",
    "5": "xl:col-span-5",
    "6": "xl:col-span-6",
    "7": "xl:col-span-7",
    "8": "xl:col-span-8",
    "9": "xl:col-span-9",
    "10": "xl:col-span-10",
    "11": "xl:col-span-11",
    "12": "xl:col-span-12"
};
var spansWithOverrideXl = {
    "1": "xl:!col-span-1",
    "2": "xl:!col-span-2",
    "3": "xl:!col-span-3",
    "4": "xl:!col-span-4",
    "5": "xl:!col-span-5",
    "6": "xl:!col-span-6",
    "7": "xl:!col-span-7",
    "8": "xl:!col-span-8",
    "9": "xl:!col-span-9",
    "10": "xl:!col-span-10",
    "11": "xl:!col-span-11",
    "12": "xl:!col-span-12"
};
/** @deprecated This generates Tailwind classes, use `formatColumnsAsStyles` instead. */ export var formatColumnsAsClassNames = function(param) {
    var _param = _sliced_to_array(param, 3), span = _param[0], breakpoint = _param[1], tmp = _param[2], ref = tmp === void 0 ? {} : tmp, _override = ref.override, override = _override === void 0 ? false : _override, _condition = ref.condition, condition = _condition === void 0 ? true : _condition;
    if (!condition) {
        return "";
    }
    switch(breakpoint){
        case "sm":
            return override ? spansWithOverrideSm[span] : spansWithoutOverrideSm[span];
        case "md":
            return override ? spansWithOverrideMd[span] : spansWithoutOverrideMd[span];
        case "lg":
            return override ? spansWithOverrideLg[span] : spansWithoutOverrideLg[span];
        case "xl":
            return override ? spansWithOverrideXl[span] : spansWithoutOverrideXl[span];
        default:
            return override ? spansWithOverride[span] : spansWithoutOverride[span];
    }
};
export var formatColumnsAsStyles = function(param) {
    var _param = _sliced_to_array(param, 3), span = _param[0], breakpoint = _param[1], tmp = _param[2], ref = tmp === void 0 ? {} : tmp, _override = ref.override, override = _override === void 0 ? false : _override, _condition = ref.condition, condition = _condition === void 0 ? true : _condition;
    if (!condition) {
        return "";
    }
    var columnStyle = "grid-column: span ".concat(span).concat(override ? " !important" : "", ";");
    if (breakpoint) {
        return /*#__PURE__*/ css(Theme.mq(breakpoint), "{", columnStyle, "}");
    }
    return /*#__PURE__*/ css(columnStyle);
};
